(function () {
  'use strict';

  angular
    .module('app')
    .controller('footerFormsController', footerFormsController);

  footerFormsController.$inject = ['$scope', 'contactService'];
  function footerFormsController($scope, contactService) {
    /* jshint validthis:true */
    var vm = this;
    var name = null;
    var contentScrollTop;
    var height = 0;
    var acceptedCookies = false;

    vm.formOpen = false;
    vm.inProgress = false;
    vm.formSubmitted = false;
    vm.errorMsg = '';

    vm.user = {
      name: '',
      email: '',
      phone: '',
      organization: '',
      messageFromSender: '',
      pageLink: '',
      blockLink: ''
    };

    vm.init = init;
    vm.closeForm = closeForm;
    vm.toggleForm = toggleForm;
    vm.openForm = openForm;
    vm.submitForm = submitForm;
    vm.resizeIfCookieBannerShows = resizeIfCookieBannerShows;
    vm.addFormStyleWhenCookieBanner = addFormStyleWhenCookieBanner;
    vm.cleanUpFormStyles = cleanUpFormStyles;

    function checkCookieBanner() {
      var dc = document.cookie;
      var acceptedCookies = dc.indexOf('OptanonAlertBoxClosed') !== null && dc.indexOf('OptanonAlertBoxClosed') > -1;

      if (!acceptedCookies) {
        acceptedCookies = $('.optanon-alert-box-wrapper').is(':visible') !== true;
      }

      setTimeout(function () {
       
        if (acceptedCookies === true) {
          $('.om-footer-forms').removeAttr('style');
          $('header').css({ 'position': 'relative', 'height': 'auto' });
          $('.sub-menu').css({ 'position': 'absolute' });
          $('#js-om-webb-content').removeAttr('style');
          $('body').removeAttr('style');
        } else {
          var matrix = new WebKitCSSMatrix($('body').css('transform'));
          $('.om-footer-forms').css({ 'transform': 'translateY(-' + matrix.m42 + 'px)' });
          $('body').css({ 'position': 'fixed', 'width': '100%', 'height': '100%', 'padding': '0' });
          $('#js-om-webb-content').css({ 'height': '100%', 'overflow': ' auto' });
          $('header').css({ 'position': 'relative' });
          $('.sub-menu').css({ 'position': '' });
          checkCookieBanner();
        }
      }, 1000);
    }

    
    function init(formName, pl, bl) {
      vm.user.pageLink = pl;
      vm.user.blockLink = bl;

      name = formName.replace(/[^a-z0-9]/gi, '-').toLowerCase();
      var openFooterFormEvent = $scope.$on('open-footer-form', function (e, fName) {
        if (fName === name) {
          openForm();
        }
      });

      $scope.$on('$destroy', function () {
        if (openFooterFormEvent) openFooterFormEvent();
      });

      window.onresize = function () {
        if (vm.formOpen === true) {
          resizeIfCookieBannerShows();
        }
      };

      height = $('.om-footer-forms').height();

      checkCookieBanner();
    }


    function addFormStyleWhenCookieBanner() {
      if (acceptedCookies === false) {
        $('body').css({ 'height': '100%', 'width': '100%', 'position': 'fixed' });
        $('#js-om-webb-content').css({ 'height': '100%', 'overflow': 'auto' });
        $('.om-footer-forms').css({ 'position': 'absolute' });
      }
    }

    function cleanUpFormStyles() {
      $('body').css({ 'height': '', 'width': '', 'position': '' });
      $('#js-om-webb-content').css({ 'height': '', 'overflow': '' });
      $('.om-footer-forms').css({ 'position': 'fixed' });
    }

    function resizeIfCookieBannerShows() {
      $('.om-footer-forms__content').css({ 'height': '' });
      var matrix = new WebKitCSSMatrix($('body').css('transform'));
      var positionY = 0;
      var viewportHeight = $(window).height();
      var startHeight = $('.om-footer-forms__content').height();

      $('.om-footer-forms').css({ 'transform': 'translateY(-' + matrix.m42 + 'px)' });

      if ($('.optanon-alert-box-wrapper').length > 0) {
        positionY = $('.optanon-alert-box-wrapper')[0].style.top;
        if (positionY !== 0 && $('.optanon-alert-box-wrapper:visible').length > 0) {
          $('.om-footer-forms').css({ 'transform': 'translateY(-' + matrix.m42 + 'px)' });
          var positionfloat = parseFloat(positionY, 10);
          if ($('.om-footer-forms').height() < 5) {
            if ((height + Math.abs(positionfloat)) > viewportHeight) {
              $('.om-footer-forms').css({ 'height': 'calc(' + height + 'px - ' + Math.abs(positionfloat) + 'px)' });
            }
          } else {
            if ((height + Math.abs(positionfloat)) > viewportHeight) {
              $('.om-footer-forms').height('100%');
              height = $('.om-footer-forms').height();
              var currentHeight = $('.om-footer-forms').height();
              $('.om-footer-forms').css({ 'height': 'calc(' + currentHeight + 'px - ' + Math.abs(positionfloat) + 'px)' });
            }
          }
          if ((height + Math.abs(positionfloat)) < viewportHeight) {
            $('.om-footer-forms').css({ 'height': '' });
          }
        } else {
          $('.om-footer-forms').css({ 'transform': '' });
          $('.om-footer-forms').css({ 'height': '' });
        }
      }

      var pos = Math.abs(parseFloat(positionY, 10));
      if (vm.formOpen && viewportHeight < (height + pos + 200)) {
        $('body').width('100%');
        $('body').css({ 'position': 'fixed' });
        $('.om-footer-forms').css({ 'overflow': 'auto' });
      }

      $('.om-footer-forms').css({ 'top': '' });
      if (acceptedCookies === false) {
        $('.om-footer-forms').css({ 'transform': 'translateY(-' + $('.optanon-alert-box-wrapper').height() + 'px)' });
        if ((viewportHeight - $('.optanon-alert-box-wrapper').height()) < startHeight) {
          $('.om-footer-forms').css({ 'top': '0' });
          $('.om-footer-forms__content').css({ 'height': '100%' });
        }
      }
    }

    function closeForm() {
      vm.formOpen = false;
      vm.errorMsg = '';
      vm.formSubmitted = false;
      vm.inProgress = false;
      cleanUpFormStyles();
      fixIphoneInputsOnFormToggle(false);
      $('.om-footer-forms').css({ 'top': '' });
    }

    function toggleForm() {
      vm.formOpen = !vm.formOpen;
      if (!vm.formOpen) {
        vm.errorMsg = '';
        vm.formSubmitted = false;
        vm.inProgress = false;
        cleanUpFormStyles();

      } else {
        addFormStyleWhenCookieBanner();
      }

      fixIphoneInputsOnFormToggle(vm.formOpen);
      resizeIfCookieBannerShows();
    }
    function openForm() {
      vm.formOpen = true;
      vm.errorMsg = '';
      vm.formSubmitted = false;
      vm.inProgress = false;
      $('.om-footer-forms').height('100%');
      addFormStyleWhenCookieBanner();
      fixIphoneInputsOnFormToggle(true);
      resizeIfCookieBannerShows();
    }

    function fixIphoneInputsOnFormToggle(isFormOpen) {
      if (!isIOS11()) return;

      // fix bug in iOS 11: the caret is put outside of text inputs in a fixed container 
      // if the inputs are close to the bottom of the page.
      if (isFormOpen) {
        contentScrollTop = $(document).scrollTop();
        $('body').addClass('mobile-fixed');
      } else {
        $('body').removeClass('mobile-fixed');
        $(document).scrollTop(contentScrollTop);
      }
    }

    function isIOS11() {
      // Detect ios version 11 
      var ua = navigator.userAgent,
        deviceIsIOS = /iPad|iPhone|iPod/.test(ua),
        deviceIsIOS11 = /OS 11_(\d{1,2})/.test(ua);

      return deviceIsIOS && deviceIsIOS11;
    }

    function submitForm() {
      vm.errorMsg = '';
      vm.formSubmitted = false;
      vm.inProgress = true;
      contactService.send(vm.user, function (result) {
        if (result === true) {
          vm.formSubmitted = true;
          vm.user = {
            name: '',
            email: '',
            phone: '',
            organization: '',
            messageFromSender: '',
            pageLink: vm.user.pageLink,
            blockLink: vm.user.blockLink
          };
        } else {
          vm.errorMsg = 'error';
        }
        ga('send', 'event', 'ProdukterTjansterFormular', 'SUBMIT', vm.user.pageLink);
      }, function (err) {
        vm.errorMsg = 'error';
      }).then(function () {
        //do nothing, this is handled by success/error functions
      }).then(function () {
        //hide loading/in-progress symbol
        vm.inProgress = false;
      });
    }
  }
})();
